import React from 'react';

/**
 * Full-screen blocking overlay for long-running fee / month-start API calls.
 */
export default function FeePostingBusyOverlay({ show, title, message, elapsedSeconds = 0 }) {
    if (!show) return null;

    const overlayStyle = {
        position: 'fixed',
        inset: 0,
        zIndex: 10050,
        backgroundColor: 'rgba(15, 23, 42, 0.58)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(3px)',
    };

    const panelStyle = {
        background: '#ffffff',
        borderRadius: '14px',
        padding: '2rem 2.25rem',
        maxWidth: '440px',
        width: '92%',
        textAlign: 'center',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
        border: '1px solid rgba(0,0,0,0.06)',
    };

    const fmt = (s) => {
        const m = Math.floor(s / 60);
        const r = s % 60;
        return m > 0 ? `${m}m ${r}s` : `${r}s`;
    };

    return (
        <div
            style={overlayStyle}
            role="alertdialog"
            aria-modal="true"
            aria-busy="true"
            aria-live="assertive"
            aria-label={title || 'Processing'}
        >
            <div style={panelStyle}>
                <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                    <span className="visually-hidden">Loading</span>
                </div>
                <h2 className="h5 fw-semibold mb-2">{title || 'Processing…'}</h2>
                {message ? <p className="text-muted small mb-3 mb-md-4">{message}</p> : null}
                <p className="small text-secondary mb-0">
                    <span className="fw-medium text-dark">{fmt(elapsedSeconds)}</span>
                    {' · '}
                    Do not close this tab or press the button again.
                </p>
            </div>
        </div>
    );
}
